import { useContent } from '@/hooks/useContent';

export default function StatsBar() {
  const { t } = useContent('home');
  const { t: statT } = useContent('stats');

  return (
    <div className="w-full bg-background-100 border-t-4 border-primary-500">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-foreground-50/10">
        <div className="flex-1 flex flex-col items-center justify-center text-center px-6 py-8">
          <div className="flex items-end gap-0.5">
            <span className="text-4xl md:text-5xl font-extrabold text-foreground-50">{statT('stats_years_value')}</span>
          </div>
          <p className="text-primary-500 font-semibold text-sm mt-1">{t('stats_experience')}</p>
          <p className="text-foreground-400/50 text-xs mt-1 leading-snug max-w-[160px]">{t('stats_experience_desc')}</p>
        </div>
        <div className="flex-1 flex flex-col items-center justify-center text-center px-6 py-8">
          <div className="flex items-end gap-0.5">
            <span className="text-4xl md:text-5xl font-extrabold text-foreground-50">{statT('stats_satisfaction_value')}</span>
          </div>
          <p className="text-primary-500 font-semibold text-sm mt-1">{t('stats_satisfaction')}</p>
          <p className="text-foreground-400/50 text-xs mt-1 leading-snug max-w-[160px]">{t('stats_satisfaction_desc')}</p>
        </div>
        <div className="flex-1 flex flex-col items-center justify-center text-center px-6 py-8">
          <div className="flex items-end gap-0.5">
            <span className="text-4xl md:text-5xl font-extrabold text-foreground-50">{t('stats_free_word')}</span>
          </div>
          <p className="text-primary-500 font-semibold text-sm mt-1">{t('stats_free')}</p>
          <p className="text-foreground-400/50 text-xs mt-1 leading-snug max-w-[160px]">{t('stats_free_desc')}</p>
        </div>
        <div className="flex-1 flex flex-col items-center justify-center text-center px-6 py-8">
          <div className="flex items-end gap-0.5">
            <span className="text-4xl md:text-5xl font-extrabold text-foreground-50">{t('stats_local_word')}</span>
          </div>
          <p className="text-primary-500 font-semibold text-sm mt-1">{t('stats_local')}</p>
          <p className="text-foreground-400/50 text-xs mt-1 leading-snug max-w-[160px]">{t('stats_local_desc')}</p>
        </div>
      </div>
    </div>
  );
}